window.FontAwesomeConfig = {
    searchPseudoElements: true
};


/* end protected downloads */

$(document).ready(function(){
    $(document).foundation();

    /* protected downloads */
    var $protectedLinks = $('.protected-download');
    var $downloadButton = $('.downloads-button');
    var $emailCaptureModal = $('#emailCaptureModal');


    $protectedLinks.hide();
    $downloadButton.show();

    jQuery(document).bind('gform_confirmation_loaded', function(event, formId){
        $protectedLinks.show();
        $downloadButton.hide();
        $emailCaptureModal.foundation('close');
    });

    $emailCaptureModal.find( '.close-reveal-modal' ).click(function () {
        $emailCaptureModal.foundation('close');
    });

    $( '.close-reveal-modal').click(function () {
        var id = $( this ).parents( '.reveal').first().attr( 'id');
        $( '#' + id ).foundation('close');
    });

    if( $('#take-over').length > 0 )
    {
        //$("#take-over").foundation("open");
        $('#take-over').foundation('open');
    }

    $('.dont-show-again').on('click', function() {
        $modalTitle = $('#take-over').data('title');

        $('#take-over').foundation('close');

        //Cookies.set('dontShowHomepageModal', $modalTitle, { expires: 14 });
        var date = new Date();
        date.setTime(date.getTime() + (30*24*60*60*1000)); // 1 month
        document.cookie = 'dontShowHomepageModal' + "=" + "1"  + "; expires=" + date.toUTCString() + "; path=/";

        return false;
    });



    ////////////////////////////////////////////////////////
    // OLD EVENTS
    ////////////////////////////////////////////////////////

    $('.js-accordion-trigger').bind('click', function(e){
        jQuery(this).parent().find('.submenu').slideToggle('fast');  // apply the toggle to the ul
        jQuery(this).parent().toggleClass('is-expanded');
        e.preventDefault();
    });

    $( '.accordion__trigger' ).click(function (e){
        e.preventDefault();
        $( this ).toggleClass( 'is-active').next( '.accordion__content' ).slideToggle(500);
    });

/*    var $grid = $( '.isotope__container' );
    var qsRegex;
    var selectFilter;

    $grid.isotope({
        itemSelector: '.item',
        layoutMode: 'masonry',
        filter: function() {
            var $this = $(this);
            var searchResult = qsRegex ? $this.text().match( qsRegex ) : true;
            var buttonResult = selectFilter ? $this.is( selectFilter ) : true;

            console.log( searchResult );
            console.log( selectFilter );
            return searchResult && buttonResult;
        }
    });

    $('.isotope__filters__select').change(function(){
        selectFilter = $(this).find( 'option:selected').val();
        $grid.isotope();
    });

    $('.isotope__filters__search__button').click(function(){
        $grid.isotope();
    });

    var $quicksearch = $('.isotope__filters__search').keyup( debounce( function() {
        qsRegex = new RegExp( $quicksearch.val(), 'gi' );
        $grid.isotope();
    }, 200 ) );

*/

    $('.accordian-title').on('click', function() {

        var holdStatus = $(this).hasClass('active');

        /*var $container = $(this).parents('.accordian-container');
        $container.toggleClass('active');*/

        $(this).parent().siblings().find('.accordian-content').attr( "style", "display:none");
        $(this).parent().siblings().find('.accordian-content').removeClass('active');
        $(this).parent().siblings().find('.accordian-title').removeClass('active');

        if (holdStatus)
        {
            $(this).removeClass('active');
            $(this).next().slideUp();
            $(this).next().removeClass('active');
        }
        else
        {
            $(this).addClass('active');
            $(this).next().slideDown();
            $(this).next().addClass('active');
        }

    });
    ////////////////////////////////////////////////////////
    // Old events end
    ////////////////////////////////////////////////////////



    if ($(".social-buttons").length) {
        $( '.social-buttons a' ).click(function( e ){
            e.preventDefault();
            m40_socialShare( this.href, 640, 480 );
        });
        window.m40_socialShare = function(url, winWidth, winHeight) {
            var winTop = (window.innerHeight / 2) - (winHeight / 2);
            var winLeft = (window.innerWidth / 2) - (winWidth / 2);
            window.open(url, 'm40_sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            return false;
        };
    }

    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }

    // Search Container - Trigger is in secondary-navigation.twig
    $(".search-trigger").on('click', function(e) {
        e.preventDefault();
        $(".search-container").toggleClass("active");
        $(".search-active-overlay").toggleClass("fade-content");
        $("html").toggleClass("no-scroll");
    });

    $(".search-close").on('click', function(e) {
        e.preventDefault();
        $(".search-container").removeClass("active");
        $(".search-active-overlay").removeClass("fade-content");
        $("html").removeClass("no-scroll");
    });

    $( '.news-item' ).hover(function(){
        $( this ).toggleClass( 'is-active' );
    });

    $( '.news-item' ).click(function(){
        $(this).find('a')[0].click();
    });

    // esc key action
    $(document).keyup(function(e) {
        if (e.keyCode == 27) { // Esc
            $(".search-container").removeClass("active");
            $(".search-active-overlay").removeClass("fade-content");
            $("html").removeClass("no-scroll");
        }
    });

    // Let's lazy load that huge homepage image
    if($(".home-search").length > 0) 
    {
        var bgUrl = $(".home-search").data('bg-image');
        $(".home-search").css('background-image', 'url(' + bgUrl + ')');
    }

    if ( $('#auto-search').length )
    {
        $('#auto-search').autocomplete({
            serviceUrl: '/wp/wp-admin/admin-post.php?action=search_suggest',
            dataType: 'json',
            paramName: 'search',
            appendTo: $('.search-suggestions'),
            showNoSuggestionNotice: true,
            width: $('#auto-search').outerWidth(),
            minChars: 3,

            onSearchStart: function () {
                $('.search-suggestions').css({
                    'width': $('#auto-search').outerWidth(),
                });

                $('.search-suggestions').addClass('loading');

            },

            onSearchComplete: function () {
                $('.search-suggestions').removeClass('loading');
            },

            onSelect: function (suggestion) {
                window.location.href = suggestion.data
            },
        });

        $('#auto-search').on('focusout', function(){
            $('.search-suggestions').removeClass('loading');
        });
    }

});




// OLD EVENTS
(function($) {


    if ($(window).width() < 1026) {
        $(".page-nav li ul").hide();
    }

    $(window).resize(function() {
        if($(window).width() < 1026){
            $(".page-nav li ul").hide();
        } else {
            $(".page-nav li ul").show();
        }
    });

    $(".page-nav h3").click(function(){
        if ($(window).width() < 1026) {
            $(".page-nav li ul").slideToggle();
            return false;
        }
    });

    $("#payment-confirmation-form").on('submit', function()
    {
        var params = {};
        $.each($(this).serializeArray(), function(_, kv) {
            if(kv.name == 'name') kv.name = 'customerName';
            params[kv.name] = kv.value;
        });

        $.ajax({
            url: '/process-payment/',
            type: 'POST',
            data: 'logOrder=1&' + params,
            async: false,
            success:function(response)
            {
                return true;
            }
        });


    });



    var $topNavItems = $('#secondary-nav').children('li.menu-item').clone().each(function(){
        $(this).addClass('show-on-mobile-menu');
    });

    $topNavItems.each(function () {
        $(this).appendTo('#cd-primary-nav');
    });




    if(window.location.hash) {
        // get the hash
        var hash = window.location.hash;
        // set an internal hash
        var hashfull = '#opening-hours-' + window.location.hash.substring(1);
        // offset height for anchor to allow for WP top bar
        var offsetSize = 100;
        // open the accordion
        $('.accordion a[href="' + hashfull + '"]').trigger('click');
        //smooth scroll
        $("html, body").animate({scrollTop:$(hash).offset().top-offsetSize }, 500);
    }

    //$.fn.dataTableExt.sErrMode = 'throw';

})(jQuery);

(function () {
    if (window.addtocalendar)if(typeof window.addtocalendar.start == "function")return;
    if (window.ifaddtocalendar == undefined) { window.ifaddtocalendar = 1;
        var d = document, s = d.createElement('script'), g = 'getElementsByTagName';
        s.type = 'text/javascript';s.charset = 'UTF-8';s.async = true;
        s.src = ('https:' == window.location.protocol ? 'https' : 'http')+'://addtocalendar.com/atc/1.5/atc.min.js';
        var h = d[g]('body')[0];h.appendChild(s); }})();



window.onload = function () {
    if( $( '#wpadminbar' ).length > 0 ) $('html').addClass( 'admin-active' );
};